@if (user() !== undefined) {
  <div class="shared-member-template-avatar">
    <ng-template *ngTemplateOutlet="avatar"></ng-template>
  </div>
}

<ng-template #avatar>
  <kendo-avatar
    [imageSrc]="avatarUrl()"
    [initials]="initials()"
    [border]="false"
    [style.width.px]="width()"
    [style.height.px]="height()"
    rounded="full"
  ></kendo-avatar>
</ng-template>
